const MIN = 60_000;
const HOUR = 60 * MIN;
const DAY = 24 * HOUR;

export function fmtRelative(iso: string): string {
  if (!iso) return '';
  const then = new Date(iso).getTime();
  const diff = Date.now() - then;
  if (diff < MIN) return 'Subido hace un momento';
  if (diff < HOUR) return `Subido hace ${Math.floor(diff / MIN)} min`;
  if (diff < DAY) return `Subido hace ${Math.floor(diff / HOUR)} h`;
  if (diff < 7 * DAY) return `Subido hace ${Math.floor(diff / DAY)} d`;
  return `Subido el ${new Date(iso).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
  })}`;
}
